import request from '@/utils/request'

// 查询销售合同列表
export function listContract(query) {
  return request({
    url: '/cont/saleContract/list',
    method: 'get',
    params: query
  })
} 

// 查询销售合同详细
export function getContract(contractId) {
  return request({
    url: '/cont/saleContract/' + contractId,
    method: 'get'
  })
}

// 新增销售合同
export function addContract(data) {
  return request({
    url: '/cont/saleContract',
    method: 'post',
    data: data
  })
}

// 修改销售合同
export function updateContract(data) {
  return request({
    url: '/cont/saleContract',
    method: 'put',
    data: data
  })
}

// 删除销售合同
export function delContract(contractId) {
  return request({
    url: '/cont/saleContract/' + contractId,
    method: 'delete'
  })
}

// 导出销售合同
export function exportContract(query) {
  return request({
    url: '/cont/saleContract/export',
    method: 'get',
    params: query
  })
}

// 下载客户导入模板
export function importTemplate() {
  return request({
    url: '/cont/saleContract/importTemplate',
    method: 'get'
  })
}